import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f87a2e10"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "currentBlockchain__icon" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<svg width=\"49\" height=\"44\" viewBox=\"0 0 49 44\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" data-v-f87a2e10><circle opacity=\"0.2\" cx=\"25\" cy=\"22\" r=\"12\" fill=\"#81CF1F\" data-v-f87a2e10><animate attributeName=\"r\" values=\"12;19;12\" dur=\"2s\" repeatCount=\"indefinite\" data-v-f87a2e10></animate></circle><circle cx=\"25\" cy=\"22\" r=\"5\" fill=\"#81CF1F\" data-v-f87a2e10><animate attributeName=\"r\" values=\"2;8;2\" dur=\"2s\" repeatCount=\"indefinite\" data-v-f87a2e10></animate></circle></svg>", 1)
const _hoisted_3 = ["value", "selected"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    onMouseover: _cache[4] || (_cache[4] = ($event: any) => ($setup.selectionView = true)),
    onMouseleave: _cache[5] || (_cache[5] = ($event: any) => ($setup.selectionView =false)),
    class: "currentBlockchain"
  }, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("p", null, _toDisplayString($setup.latestBlock.height), 1 /* TEXT */)
    ]),
    _createVNode(_Transition, { name: "slide-fade" }, {
      default: _withCtx(() => [
        ($setup.selectionView || $setup.selectionView2)
          ? (_openBlock(), _createElementBlock("select", {
              key: 0,
              onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.selectionView2 = true)),
              onFocusout: _cache[2] || (_cache[2] = ($event: any) => ($setup.selectionView2=false)),
              class: "currentBlockchain__selector",
              onChange: _cache[3] || (_cache[3] = ($event: any) => ($setup.onChange($event)))
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.configMap, ([key, items]) => {
                return (_openBlock(), _createElementBlock("option", {
                  onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.selectionView2 = false)),
                  key: key,
                  value: key,
                  selected: $setup.curentNetwork === items.networkName
                }, _toDisplayString(items.networkName), 9 /* TEXT, PROPS */, _hoisted_3))
              }), 128 /* KEYED_FRAGMENT */))
            ], 32 /* NEED_HYDRATION */))
          : _createCommentVNode("v-if", true)
      ]),
      _: 1 /* STABLE */
    })
  ], 32 /* NEED_HYDRATION */))
}